import type {FC} from 'react';
import type {MultiValueProps} from 'react-select';

import {i18n} from '@yourcoach/i18n';

import {Text} from '../../../Text';

export const SelectMultiValueV2: FC<SelectMultiValueV2.Props> = props => {
  const shouldRender = props.index === 0;

  if (!shouldRender) return null;

  const selectedAmount = props.getValue().length;

  return (
    <Text>{i18n.t('shared:selected_count', {count: selectedAmount})}</Text>
  );
};

export namespace SelectMultiValueV2 {
  export type Props = MultiValueProps;
}
